import { DataTableColumnHeader } from "@/components/ui";
import type {
  ReportsRoleAssignmentRow,
  ReportsRoleAssignmentStatus,
} from "@/lib/types";
import type { ColumnDef } from "@tanstack/react-table";

const countColumn = (
  id: string,
  accessor: (row: ReportsRoleAssignmentRow) => number,
  preserveHeaderLabel = false,
): ColumnDef<ReportsRoleAssignmentRow> => ({
  accessorFn: accessor,
  id,
  meta: preserveHeaderLabel ? { preserveHeaderLabel: true } : undefined,
  header: ({ column }) => <DataTableColumnHeader column={column} />,
  cell: ({ getValue }) => getValue<number>().toLocaleString(),
  enableSorting: true,
});

export const getRoleAssignmentStatusColumnId = (
  status: ReportsRoleAssignmentStatus,
  statuses: ReportsRoleAssignmentStatus[],
) =>
  statuses.filter((item) => item.label === status.label).length > 1
    ? `${status.categoryLabel}: ${status.label}`
    : status.label;

export const getRoleAssignmentsReportColumns = (
  statuses: ReportsRoleAssignmentStatus[],
): ColumnDef<ReportsRoleAssignmentRow>[] => [
  {
    accessorFn: (row) => row.userName ?? "Restricted user",
    id: "User",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: ({ getValue }) => getValue<string>(),
    enableHiding: false,
  },
  countColumn("Total", (row) => row.totalMatters),
  countColumn("In last 24 hours", (row) => row.assignedLast24Hours),
  countColumn("In last 7 days", (row) => row.assignedLast7Days),
  countColumn("In last 30 days", (row) => row.assignedLast30Days),
  ...statuses.map((status) =>
    countColumn(
      getRoleAssignmentStatusColumnId(status, statuses),
      (row) => row.statusCounts[status.id] ?? 0,
      true,
    ),
  ),
];
